<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.75 15.6211V3.91406C19.75 3.35156 19.3984 3 18.8359 3H7.375C5.44141 3 4 4.47656 4 6.375V17.625C4 19.5586 5.44141 21 7.375 21H18.8359C19.293 21 19.75 20.6836 19.75 20.1211V19.5586C19.75 19.3125 19.6094 19.1016 19.3984 18.8906C19.293 18.3281 19.293 16.7461 19.3984 16.2891C19.6094 16.1836 19.75 15.9375 19.75 15.6211ZM17.3594 18.75H7.375C6.67188 18.75 6.25 18.3281 6.25 17.625C6.25 16.957 6.8125 16.5 7.375 16.5H17.3594V18.75Z"
        />
    </svg>
</template>
